import { SquaresSection, Square, Image, Title } from "./SquaresStyle"

const Squares = ({items}) => {
  return (
    <SquaresSection>
        {items.map((value, index) => (
        <Square
        key={index}
        to={value.path}
        >
            <Image src={value.src}/>
            <Title>
                {value.title}
            </Title>
        </Square>
        ))}
    </SquaresSection>
  )
}

export default Squares